import { ASSET_CLASS_LABEL_MAPPING } from '@ddt-web/common';
import { ColumnConfig, ColumnConfigOptions, ColumnText, ConditionalExtractor, ExtractAndFormatExtractor, LodashExtractor, MappedValueFormatter, StoreLodashExtractor } from '@ddt-web/data-service';
import { MeQueryParamKey } from '@ddt-web/url';

export const MODEL_FAMILY_COLUMN_CONFIG = new ColumnConfig(
	null,
	null,
	new StoreLodashExtractor(['familyOverview'], 'id')
);

export const FAMILY_COLUMN_CONFIG = new ColumnConfig(
	null,
	null,
	new StoreLodashExtractor(['families'], 'id')
);

export const MODEL_HOLDINGS_COLUMN_CONFIG = new ColumnConfig(
	null,
	null,
	new StoreLodashExtractor(['familyHoldings'], 'id')
);

export const FAMILY_HOLDING_COLUMN_CONFIG = new ColumnConfig(
	null,
	null,
	new StoreLodashExtractor(['familyHoldings'], 'id')
);

export const FAMILY_PERFORMANCE_COLUMN_CONFIG = new ColumnConfig(
	null,
	null,
	new StoreLodashExtractor(['familyPerformance'], 'id')
);

export const MODEL_PORTFOLIO_FILTER_BY_GROUP_ID = (portfolio: any) => {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const groupId = urlSearchParams.get(MeQueryParamKey.GROUP_ID);
	return groupId ? portfolio?.groups?.map(element => element.id).includes(groupId) : true;
};

export const MODEL_PORTFOLIO_FILTER_SELECTED_IDS = (portfolio: any) => {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const selectedIds = urlSearchParams.get(MeQueryParamKey.SELECTED_MODEL_IDS);
	return selectedIds ? selectedIds.includes(portfolio.id) : true;
};

export const HOLDINGS_ENRICHER = (holding, data) => {
	const positionDetail = data.positionDetails?.children?.find(child => child.ticker === holding.posInfo?.ticker?.stringValue);
	const acAssetClassObject = positionDetail?.assetBreakdowns?.acAssetClass?.values ?? {};
	const formattedAcAssetClass = new MappedValueFormatter(ASSET_CLASS_LABEL_MAPPING).format(Object.keys(acAssetClassObject)[0]);
	const weight = holding.weight * 100;
	const changesToHoldings = holding.posInfo.changes.numberValue * 100;
	const asOfDate = data?.familyHoldings?.metadata?.currentRebalanceDate;
	return { ...holding, formattedAcAssetClass, weight, changesToHoldings, asOfDate };
};

export const MODEL_SHORT_NAME_COLUMN = ColumnConfig.create({
	id: 'modelShortName',
	label: new ColumnText('MODEL', 'Model'),
	extractor: new ConditionalExtractor(
		model => model.managementType === 'research' && model.pkg !== 'ACT-LAM',
		new ExtractAndFormatExtractor('shortName', '', (description) => '*' + description),
		new LodashExtractor('shortName', '')
	)
} as ColumnConfigOptions<ConditionalExtractor>);

export const MODEL_PORTFOLIO_FILTER_FUNCTION = (portfolio: any) => {
	const urlSearchParams = new URLSearchParams(window.location.search);
	const selectedIds = urlSearchParams.get(MeQueryParamKey.SELECTED_MODEL_IDS);
	return selectedIds ? MODEL_PORTFOLIO_FILTER_BY_GROUP_ID(portfolio) && MODEL_PORTFOLIO_FILTER_SELECTED_IDS(portfolio) : MODEL_PORTFOLIO_FILTER_BY_GROUP_ID(portfolio);
};
